import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, useNavigate } from 'react-router-dom';
import { set_user } from 'Store/reducers/userReducer';
import { setErrorToastState } from 'Store/action';
import { AppDispatch } from 'Store/Store';
import api from '../helpers/axios-interceptor/api';

type AdminProtectedRouteType = {
  children: React.ReactElement;
};

const AdminProtectedRoute: React.FC<AdminProtectedRouteType> = ({
  children,
}: AdminProtectedRouteType) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const dispatch = useDispatch<AppDispatch>();
  const route = useNavigate();

  useEffect(() => {
    if (user?.id) {
      api
        .post('/users/me', {})
        .then(res => {
          dispatch(set_user(res.data));
          localStorage.setItem('user', JSON.stringify(res.data));
        })
        .catch(err => {
          dispatch(setErrorToastState(true, 'Something went wrong, please try again in a while.'));
        });
    }
  }, [dispatch, route, user]);

  if (user?.id && user?.is_super_admin) {
    return children;
  }

  return <Navigate to="/" />;
};

export default AdminProtectedRoute;
